import type { RegistrationProgressResponse } from '@diamond/shared/features/registration/browser';

export const WHATSAPP_SUPPORT_URL = 'https://www.sukandaonelink.com/hubungi-kami';
export const NOO_NAV_GRADIENT =
  'linear-gradient(90deg, #FF1E1E 0%, #2451CE 50%, #5AC8FF 100%)';
export const NOO_ICON_STROKE = '#00003D';

export type RegistrationBusinessProfile = NonNullable<
  RegistrationProgressResponse['business']
>;
export type RegistrationOutlet = RegistrationProgressResponse['outlets'][number];
export type RegistrationOutletAttachment =
  RegistrationOutlet['attachments'][number];

export const DESKTOP_ATTACHMENT_META = [
  { type: 'pic_photo', label: 'Foto PIC Outlet', image: true },
  { type: 'outlet_photo', label: 'Foto Outlet', image: true },
  { type: 'kitchen_photo', label: 'Foto Dapur', image: true },
  { type: 'menu_photo', label: 'Upload Menu', image: false },
] as const;

export function getOutletAttachmentLabel(
  item: (typeof DESKTOP_ATTACHMENT_META)[number],
  outlet: RegistrationOutlet | undefined
): string {
  if (item.type === 'menu_photo' && outlet?.use_primary_outlet_menu) {
    return 'Gunakan menu utama';
  }

  return item.label;
}

const ATTACHMENT_IMAGE_PREVIEW_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.gif',
] as const;

export function attachmentHasImagePreview(
  attachment: RegistrationOutletAttachment | undefined
): boolean {
  if (!attachment?.file_url?.trim()) {
    return false;
  }

  const fileUrlPath = attachment.file_url.split('?')[0]?.toLowerCase() ?? '';
  const originalFilename = attachment.original_filename?.toLowerCase() ?? '';
  const candidates = [fileUrlPath, originalFilename];

  return ATTACHMENT_IMAGE_PREVIEW_EXTENSIONS.some((extension) =>
    candidates.some((value) => value.endsWith(extension))
  );
}

export function displayValue(value: string | null | undefined): string {
  return value?.trim() || '-';
}

export function joinName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string {
  return [firstName, lastName].filter(Boolean).join(' ') || '-';
}

export function resolveVerificationOutlet(
  outlets: RegistrationOutlet[],
  section: { outletId?: string; outletIndex?: number } | undefined
): RegistrationOutlet | undefined {
  if (!section) {
    return undefined;
  }

  if (section.outletId) {
    const byId = outlets.find((outlet) => outlet.id === section.outletId);
    if (byId) {
      return byId;
    }
  }

  if (typeof section.outletIndex === 'number') {
    return outlets[section.outletIndex];
  }

  return undefined;
}

export const NOO_STATUS_UBUNTU_TITLE = {
  fontFamily: 'Ubuntu, sans-serif',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '36px',
  color: '#373F41',
} as const;
